import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { fill_action } from '../../../actions/fillCombo_action';
import { BASE_URL, countryActionId, enterpriseTypeActionId, organisationTypeActionId, toastError, toastSuccess, tradeServiceTypeActionId } from '../../../utils/constants';
import { getEnquiryRegDetails_action, insertEnquiry_action, } from '../../../actions/staticAction/enquiryForm_action';
import { getEnquiryDetails_action } from '../../../actions/adminAction/enquiry_action';
import { Facebook } from '@mui/icons-material';
import moment from 'moment';
import { countDownDate_action } from '../../../actions/staticAction/static_action';

class Enquiry_Form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMember: '',
            isLoading: false, EnquiryID: '',
            MemberID: '', registrationNo: '',
            CompanyName: '', OrganizationTypeID: '',
            Title: '', FirstName: '',
            LastName: '', Designation: '',
            CountryID: '', PhoneNo: '', MobileNo: '', Email: '',
            EnterpriseTypeID: '', BusinessSegments: '',
            TradeServicesID: '', Query: '',
            countryList: [], tradeServiceTypeList: [],
            organisationTypeList: [], enterpriseTypeList: [],
            //validators
            isregTypeErr: '', regNoErr: '', CompanyNameErr: '', OrganizationTypeIDErr: '',
            TitleErr: '', FirstNameErr: '', LastNameErr: '', DesignationErr: '',
            CountryIDErr: '', PhoneNoErr: '', MobileNoErr: '', EnterpriseTypeIDErr: '',
            BusinessSegmentsErr: '', TradeServicesIDErr: '', QueryErr: '', EmailErr: '',

            EnquiryID: '',
            isViewFlag: false,
            //cms
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: []
        }
        this.slider3Ref = React.createRef()
    }
    async componentDidMount() {
        // const isTimeout = await this.getCountDownDate();
        // if (isTimeout) {
        //     this.props.navigate('/')
        // } else {
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'enquiryForm')
        this.getFillList(countryActionId, '', '', '', '').then(() => {
            this.getFillList(tradeServiceTypeActionId, '', '', '', '').then(() => {
                this.getFillList(organisationTypeActionId, '', '', '', '').then(() => {
                    this.getFillList(enterpriseTypeActionId, '', '', '', '').then(() => {
                        if (sessionStorage.getItem('RoleIDSS') != 5) {
                            this.setState({ EnquiryID: this.props?.location?.state?.EnquiryID }, () => {
                                if ((this.props?.location?.state?.EnquiryID != null)) {
                                    console.log(sessionStorage.getItem('RoleIDSS'))
                                    this.setState({ isViewFlag: true })
                                    this.getDetails(this.props?.location?.state?.EnquiryID)
                                }
                            })
                        }
                        this.setState({ isLoading: false })
                    })
                })
            })
        })

    }

    getCountDownDate() {
        const { } = this.state
        this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['enquiryDate']
                        const targetDate = moment.utc(LaunchDate);
                        // Current date in UTC
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        return totalSeconds > 0;
                    }
                    this.setState({ isLoading: false })
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    getDetails(EnquiryID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.getEnquiryDetails_action(EnquiryID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0][0])
                    const enqData = data.data[0][0]
                    this.setState({
                        registrationNo: enqData.MembershipNo,
                        CompanyName: enqData.CompanyName,
                        OrganizationTypeID: enqData.OrganizationTypeID,
                        Title: enqData.Title,
                        FirstName: enqData.FirstName,
                        LastName: enqData.LastName,
                        Designation: enqData.Designation,
                        CountryID: enqData.CountryID,
                        PhoneNo: enqData.PhoneNo,
                        MobileNo: enqData.MobileNo,
                        Email: enqData.Email,
                        EnterpriseTypeID: enqData.EnterpriseTypeID,
                        BusinessSegments: enqData.BusinessSegments,
                        TradeServicesID: enqData.TradeServicesID,
                        Query: enqData.Query,
                        isMember: enqData.MemberID != null ? 1 : 0,
                        MemberID: enqData.MemberID
                    })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }
    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        if (actionID === tradeServiceTypeActionId) {
                            this.setState({ tradeServiceTypeList: data.data })
                            resolve(true)
                        }
                        if (actionID === organisationTypeActionId) {
                            this.setState({ organisationTypeList: data.data })
                            resolve(true)
                        }
                        if (actionID === enterpriseTypeActionId) {
                            this.setState({ enterpriseTypeList: data.data })
                            resolve(true)
                        }

                    }
                })
        })
    }
    onRegNoChange(e) {
        const { registrationNo, PhoneNo } = this.state;
        // this.setState({ registrationNo: e.target.value, regNoErr: '' })
        console.log(registrationNo)
        if (registrationNo.length > 12) {
            this.setState({ isLoading: true })
            this.props.getEnquiryRegDetails_action(registrationNo)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data[0]['MemberID'])
                        if (data.data[0]['MemberID'] != 0 && data.data[0]['MemberID'] != '') {
                            this.setState({
                                // registrationNo: data.data[0]['MembershipNo'],
                                CompanyName: data.data[0]['CompanyName'],
                                Title: data.data[0]['Title'],
                                PhoneNo: data.data[0]['PhoneNumber'],
                                // MobileNo: data.data[0]['PhoneNoNumber'],
                                FirstName: data.data[0]['ContactPersonName'],
                                Designation: data.data[0]['ContactPersonDesignation'],
                                CountryID: data.data[0]['CountryID'],
                                Email: data.data[0]['EmailAddress'],
                                MemberID: data.data[0]['MemberID'],
                                isMember: 1,
                                isLoading: false
                            })
                        } else {
                            this.setState({
                                MemberID: '',
                                regNoErr: 'Invalid Registration No',
                                isLoading: false
                                // isMember: false,
                            })
                            // setTimeout(() => {
                            toastError("This registration no is not registered within our system. Please check your registration no.")
                            // }, 100);
                        }
                    }
                }).catch((err) => console.error(err))
        }
    }

    inputValidation() {
        const { MemberID, registrationNo, CompanyName, OrganizationTypeID,
            Title, FirstName, LastName, Designation, CountryID, Email,
            PhoneNo, EnterpriseTypeID, BusinessSegments,
            TradeServicesID, Query, isMember } = this.state
        var Err = false
        this.setState({
            isregTypeErr: '', regNoErr: '', CompanyNameErr: '', OrganizationTypeIDErr: '',
            TitleErr: '', FirstNameErr: '', LastNameErr: '', DesignationErr: '',
            CountryIDErr: '', EmailErr: '', PhoneNoErr: '', EnterpriseTypeIDErr: '',
            BusinessSegmentsErr: '', TradeServicesIDErr: '', QueryErr: '', isMemberErr: ''
        })
        return new Promise((resolve) => {
            if (isMember != 0 && isMember != '') {
                console.log("here", isMember)
                if (registrationNo == '' || registrationNo == null) {
                    Err = true
                    this.setState({ regNoErr: 'Please enter Registration Number' })
                }
            } if (isMember == '' || isMember == null) {
                Err = true
                this.setState({ isregTypeErr: 'Please Select Registration Type' })
            } if (CompanyName == '' || CompanyName == null) {
                Err = true
                this.setState({ CompanyNameErr: 'Please enter Company Name' })
            } if (OrganizationTypeID == '' || OrganizationTypeID == null) {
                Err = true
                this.setState({ OrganizationTypeIDErr: 'Please select Organisation Type' })
            } if (Title == '' || Title == null) {
                Err = true
                this.setState({ TitleErr: 'Please select Title' })
            } if (FirstName == '' || FirstName == null) {
                Err = true
                this.setState({ FirstNameErr: 'Please enter First Name' })
            } if (LastName == '' || LastName == null) {
                Err = true
                this.setState({ LastNameErr: 'Please enter Last Name' })
            } if (Designation == '' || Designation == null) {
                Err = true
                this.setState({ DesignationErr: 'Please enter Designation' })
            } if (PhoneNo == '' || PhoneNo == null) {
                Err = true
                this.setState({ PhoneNoErr: 'Please enter Mobile Number' })
            } if (!Email || Email.trim() === '') {
                Err = true;
                this.setState({ EmailErr: 'Please enter Email Address' });
            } else {
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailRegex.test(Email)) {
                    Err = true;
                    this.setState({ EmailErr: 'Please enter a valid Email Address' });
                } else {
                    this.setState({ EmailErr: '' });
                }
            }
            // if (MobileNo == '' || MobileNo == null) {
            //     Err = true
            //     this.setState({ MobileNoErr: 'Please enter Mobile Number' })
            // } 
            if (EnterpriseTypeID == '' || EnterpriseTypeID == null) {
                Err = true
                this.setState({ EnterpriseTypeIDErr: 'Please select Enterprise Type' })
            } if (BusinessSegments == '' || BusinessSegments == null) {
                Err = true
                this.setState({ BusinessSegmentsErr: 'Please enter Business/Industry Segment' })
            } if (TradeServicesID == '' || TradeServicesID == null) {
                Err = true
                this.setState({ TradeServicesIDErr: 'Please select Query for Service' })
            } if (Query == '' || Query == null) {
                Err = true
                this.setState({ QueryErr: 'Please enter Query' })
            } if (CountryID == '' || CountryID == null) {
                Err = true
                this.setState({ CountryIDErr: 'Please select Country' })
            }
            resolve(Err)
        })
    }
    submitEnquiry() {
        this.inputValidation().then(res => {
            console.log(res)
            if (!res) {
                const { EnquiryID, MemberID, OrganizationTypeID, CompanyName, Title, PhoneNo, isMember, FirstName, LastName, Email, Designation, CountryID, MobileNo, EnterpriseTypeID, BusinessSegments, TradeServicesID, Query, EventID } = this.state;
                this.props.insertEnquiry_action(EnquiryID, MemberID, OrganizationTypeID, CompanyName, Title, FirstName, LastName, Email, Designation, CountryID, PhoneNo, MobileNo, EnterpriseTypeID, BusinessSegments, TradeServicesID, Query, EventID)
                    .then((data) => {
                        if (data.error != 1) {
                            toastSuccess('Query Submitted Successfully')
                            this.setState({
                                MemberID: '', registrationNo: '', CompanyName: '', OrganizationTypeID: '',
                                Title: '', FirstName: '', LastName: '', Designation: '', isMember: "",
                                CountryID: '', PhoneNo: '', MobileNo: '', Email: '',
                                EnterpriseTypeID: '', BusinessSegments: '',
                                TradeServicesID: '', Query: '',
                            })
                        }
                    }).catch((e) => console.error(e))
            } else {
                toastError('Please Enter Mandatory Fields')
            }
        })
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    render() {
        const { isLoading, MemberID, registrationNo, CompanyName, OrganizationTypeID, FirstName, Title, isMember, isregTypeErr,
            LastName, Designation, CountryID, PhoneNo, MobileNo, EnterpriseTypeID, BusinessSegments, countryList, tradeServiceTypeList,
            enterpriseTypeList, organisationTypeList, TradeServicesID, Query, regNoErr, CompanyNameErr, OrganizationTypeIDErr,
            TitleErr, FirstNameErr, LastNameErr, DesignationErr,
            CountryIDErr, PhoneNoErr, MobileNoErr, EnterpriseTypeIDErr, Email, EmailErr,
            BusinessSegmentsErr, TradeServicesIDErr, QueryErr, isViewFlag,
            cmsSectionData, cmsMenuData, cmsFooterData } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <Header headerNavs={cmsMenuData} />
                <section className="registration_form">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="contact-form">
                                    <div className="first-container"></div>
                                    <div className="second-container">
                                        <h2>Enquiry Form</h2>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Are you a registered user?<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={isMember} id="privileges" disabled={isViewFlag} onChange={(e) => this.setState({ isMember: e.target.value, isregTypeErr: '' })}>
                                                        <option value={''}>Select</option>
                                                        <option value={1}>Yes</option>
                                                        <option value={0}>No</option>
                                                    </select>
                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{isregTypeErr}</span>}
                                                </div>
                                            </div>
                                            {isMember == 1 ? <>
                                                <div className="col-md-6 registration_no_show_hide">
                                                    <div className="form-group">
                                                        <label>Registration No<span className="red-star text-danger">*</span></label>
                                                        <input type="text" value={registrationNo}
                                                            onBlur={() => this.onRegNoChange()}
                                                            // onPaste={(e) => this.handlePaste(e)}
                                                            onChange={(e) => this.setState({ registrationNo: e.target.value, regNoErr: '' })}
                                                            className="form-control" disabled={isViewFlag}
                                                            placeholder="Enter Registration no"
                                                        /> {<span className='text-danger text-start text-left d-block  ml-2'>{regNoErr}</span>}
                                                    </div>
                                                </div>
                                            </> : <></>}
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={CompanyName}
                                                        onChange={(e) => this.setState({ CompanyName: e.target.value, CompanyNameErr: '' })}
                                                        className="form-control" maxLength={500}
                                                        placeholder="Enter Company name" disabled={isViewFlag}
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{CompanyNameErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Organisation type<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={OrganizationTypeID} disabled={isViewFlag}
                                                        onChange={(e) => this.setState({ OrganizationTypeID: e.target.value, OrganizationTypeIDErr: '' })}>
                                                        <option value={''}>Select Organisation type</option>
                                                        {organisationTypeList.length > 0 && organisationTypeList.map((data) => (
                                                            <option key={data.organisationID} value={data.organisationID} >{data.organisationName}</option>
                                                        ))}
                                                    </select> {<span className='text-danger text-start text-left d-block  ml-2'>{OrganizationTypeIDErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Salutation<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={Title} disabled={isViewFlag}
                                                        onChange={(e) => this.setState({ Title: e.target.value, TitleErr: '' })}>
                                                        <option value={''}>Select Salutation</option>
                                                        <option value="Mr">Mr</option>
                                                        <option value="Ms">Ms</option>
                                                        <option value="Mrs">Mrs</option>
                                                        <option value="Prof">Prof</option>
                                                    </select> {<span className='text-danger text-start text-left d-block  ml-2'>{TitleErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>First Name<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={FirstName} disabled={isViewFlag} maxLength={100}
                                                        className="form-control" onChange={(e) => this.setState({ FirstName: e.target.value, FirstNameErr: '' })}
                                                        placeholder="Enter First Name"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{FirstNameErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Last Name<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={LastName} disabled={isViewFlag} maxLength={100}
                                                        className="form-control" onChange={(e) => this.setState({ LastName: e.target.value, LastNameErr: '' })}
                                                        placeholder="Enter Last Name"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{LastNameErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Designation<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={Designation} disabled={isViewFlag} maxLength={50}
                                                        onChange={(e) => this.setState({ Designation: e.target.value, DesignationErr: '' })}
                                                        className="form-control"
                                                        placeholder="Enter Designation"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{DesignationErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Country<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={CountryID} disabled={isViewFlag}
                                                        onChange={(e) => this.setState({ CountryID: e.target.value, CountryIDErr: '' })}
                                                    >
                                                        <option value={''}>Select Your Country</option>
                                                        {countryList.length > 0 && countryList.map((data) => (
                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                        ))}
                                                    </select>
                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{CountryIDErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Mobile No<span className="red-star text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        value={this.state.PhoneNo}
                                                        disabled={this.state.isViewFlag}
                                                        maxLength={12}
                                                        onChange={(e) => {
                                                            const phone = e.target.value;
                                                            if (/^\d*$/.test(phone)) {  // Only numbers allowed
                                                                this.setState({ PhoneNo: phone, PhoneNoErr: '' });
                                                            } else {
                                                                this.setState({ PhoneNoErr: 'Only numbers are allowed' });
                                                            }
                                                        }}
                                                        className="form-control"
                                                        placeholder="Enter Mobile No"
                                                    />
                                                    {this.state.PhoneNoErr && <span className="text-danger text-start text-left d-block ml-2">{this.state.PhoneNoErr}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Landline No</label>
                                                    {/* <span className="red-star text-danger">*</span>*/}
                                                    <input
                                                        type="text"
                                                        value={this.state.MobileNo}
                                                        disabled={this.state.isViewFlag}
                                                        maxLength={CountryID == 91 ? 10 : 20}
                                                        onChange={(e) => {
                                                            const mobile = e.target.value;
                                                            if (/^\d*$/.test(mobile)) {  // Only numbers allowed
                                                                this.setState({ MobileNo: mobile, MobileNoErr: '' });
                                                            } else {
                                                                this.setState({ MobileNoErr: 'Only numbers are allowed' });
                                                            }
                                                        }}
                                                        className="form-control"
                                                        placeholder="Enter Landline No"
                                                    />
                                                    {/* {this.state.MobileNoErr && <span className="text-danger text-start text-left d-block ml-2">{this.state.MobileNoErr}</span>} */}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Email Address<span className="red-star text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        value={Email}
                                                        disabled={isViewFlag} maxLength={100}
                                                        onChange={(e) => {
                                                            const email = e.target.value;
                                                            this.setState({
                                                                Email: email,
                                                                EmailErr: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) || email === '' ? '' : 'Invalid email format'
                                                            });
                                                        }}
                                                        className="form-control"
                                                        placeholder="Enter Email Address"
                                                    />
                                                    {EmailErr && <span style={{ color: 'red', fontSize: '12px' }}>{EmailErr}</span>}

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Enterprise type<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={EnterpriseTypeID} disabled={isViewFlag}
                                                        onChange={(e) => this.setState({ EnterpriseTypeID: e.target.value, EnterpriseTypeIDErr: '' })}>
                                                        <option value={''}>Select Enterprise type</option>
                                                        {enterpriseTypeList.length > 0 && enterpriseTypeList.map((data) => (
                                                            <option key={data.enterpriseID} value={data.enterpriseID} >{data.enterpriseName}</option>
                                                        ))}
                                                    </select> {<span className='text-danger text-start text-left d-block  ml-2'>{EnterpriseTypeIDErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Business/Industry Segments<span className="red-star text-danger">*</span></label>
                                                    <input type="text" value={BusinessSegments} disabled={isViewFlag} maxLength={500}
                                                        onChange={(e) => this.setState({ BusinessSegments: e.target.value, BusinessSegmentsErr: '' })}
                                                        className="form-control"
                                                        placeholder="Enter Business Segment"
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{BusinessSegmentsErr}</span>}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Your Query for service<span className="red-star text-danger">*</span></label>
                                                    <select className="form-control" value={TradeServicesID} disabled={isViewFlag}
                                                        onChange={(e) => this.setState({ TradeServicesID: e.target.value, TradeServicesIDErr: '' })}>
                                                        <option value={''}>Select Service</option>
                                                        {tradeServiceTypeList.length > 0 && tradeServiceTypeList.map((data) => (
                                                            <option key={data.TradeServicesID} value={data.TradeServicesID} >{data.TradeServicesName}</option>
                                                        ))}
                                                    </select> {<span className='text-danger text-start text-left d-block  ml-2'>{TradeServicesIDErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Message/Query<span className="red-star text-danger">*</span></label>
                                                    <textarea rows={2} value={Query} maxLength={1000}
                                                        onChange={(e) => this.setState({ Query: e.target.value, QueryErr: '' })}
                                                        className="form-control" disabled={isViewFlag}
                                                        placeholder="Type here..."
                                                        defaultValue={""}
                                                    /> {<span className='text-danger text-start text-left d-block  ml-2'>{QueryErr}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-center">
                                                <button className="btn btn-primary submit_btn" disabled={isViewFlag} onClick={() => this.submitEnquiry()}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer footerData={cmsFooterData} />
            </>
        )

    }
}

export default withRouter(connect(null, { fill_action, getEnquiryRegDetails_action, insertEnquiry_action, getEnquiryDetails_action, countDownDate_action })(Enquiry_Form));